import React, { useState, useEffect } from "react";
import "./index.less";
import phoneIcon from "../../assets/icons/phone-icon.svg";
import topIcon from "../../assets/icons/top-icon.svg";
import toTop from '../../assets/newVersion/bottom/to-top.svg'
import phoneUs from '../../assets/newVersion/bottom/phone-us.svg'
import phoneUsHover from '../../assets/newVersion/bottom/phone-us-hover.svg'  // 确保有 hover 版本
import toTopHover from '../../assets/newVersion/bottom/to-top-hover.svg'

const FloatingButtons: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [showPhoneTooltip, setShowPhoneTooltip] = useState(false);
  
  // 添加 hover 状态
  const [phoneHover, setPhoneHover] = useState(false);
  const [topHover, setTopHover] = useState(false);

  // 滚动阈值，当滚动超过这个高度时显示按钮
  const SCROLL_THRESHOLD = 300;

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const shouldShow = scrollTop > SCROLL_THRESHOLD;

      if (shouldShow && !isScrolled) {
        setIsScrolled(true);
        setIsVisible(true);
      } else if (!shouldShow && isScrolled) {
        setIsScrolled(false);
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isScrolled]);

  const handlePhoneClick = () => {
    console.log("拨打电话");
    // window.location.href = "tel:+86-13121612261";
  };

  const handleTopClick = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className={`floating-buttons ${isVisible ? "visible" : "hidden"}`}>
      <div
        className="phone-button-container"
        onMouseEnter={() => setShowPhoneTooltip(true)}
        onMouseLeave={() => setShowPhoneTooltip(false)}
      >
        <button
          className="floating-button phone-button"
          onClick={handlePhoneClick}
          onMouseEnter={() => setPhoneHover(true)}
          onMouseLeave={() => setPhoneHover(false)}
          aria-label="拨打电话"
          title="拨打电话"
        >
          <img 
            src={phoneHover ? phoneUsHover : phoneUs} 
            alt="电话" 
          />
        </button>
        {showPhoneTooltip && (
          <div className="phone-tooltip">
            <div className="phone-tooltip-content">
              <div>
                <span>联系大方：</span>
                <span>+86-13121162261</span>
              </div>
              {/* <div>
                <span>联系HR：</span>
                <span>+86-13121162261</span>
              </div> */}  
            </div>
            <div className="tooltip-arrow"></div>
          </div>
        )}
      </div>
      <button
        className="floating-button top-button"
        onClick={handleTopClick}
        onMouseEnter={() => setTopHover(true)}
        onMouseLeave={() => setTopHover(false)}
        aria-label="回到顶部"
        title="回到顶部"
      >
        <img 
          src={topHover ? toTopHover : toTop} 
          alt="置顶"
        />
      </button>
    </div>
  );
};

export default FloatingButtons;